import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { ENABLE_TEMPLATE_MARKETPLACE_SEARCH } from '@utils/constants';
import { useExperiments } from '@wix/fe-essentials-standalone';

export const useFiltersShouldClearSearch = (): boolean => {
  const { experiments } = useExperiments({ readOnly: true });
  const isSearchEnabled = experiments.enabled(
    ENABLE_TEMPLATE_MARKETPLACE_SEARCH,
  );

  const {
    state: { numberOfResults, filters },
  } = useTemplatesContext();

  return isSearchEnabled && !numberOfResults && Boolean(filters.search);
};
